import {
  LargeHeadingStyled,
  SectionHeaderStyled,
} from "../../../components/custom/texts/texts.styled";
import { Layout, Tabs, TabsProps } from "antd";
import React from "react";
import GeneralSettingsView from "../generalSettings/generalSettings";
import { Services } from "../servicesAdmin";
import { Users } from "../users";
import { BanksSettings } from "../banksSettings";
import { EmailTemplates } from "../emailTemplates";
import { Sponsors } from "../sponsors";
import { RequestsConfig } from "../requestConfig";
import { ColumnContainer } from "src/components/layout/main-layout/main-layout.styled";

const { Content } = Layout;

const Settings: React.FC = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Configuraciones generales`,
      children: <GeneralSettingsView />,
    },
    {
      key: "2",
      label: `Servicios`,
      children: <Services />,
    },
    {
      key: "4",
      label: `Bancos`,
      children: <BanksSettings />,
    },
    {
      key: "5",
      label: `Plantillas`,
      children: <EmailTemplates />,
    },
    {
      key: "6",
      label: `Patrocinadores`,
      children: <Sponsors />,
    },
    {
      key: "7",
      label: `Solicitudes`,
      children: <RequestsConfig />,
    },
    {
      key: "8",
      label: `Usuarios`,
      children: <Users />,
    },
  ];

  return (
    <ColumnContainer>
      <SectionHeaderStyled>
        <LargeHeadingStyled>Configuraciones</LargeHeadingStyled>
      </SectionHeaderStyled>

      <Content style={{ marginTop: "16px" }}>
        <Tabs
          tabBarStyle={{
            justifyContent: "space-between",
            width: "100%",
          }}
          defaultActiveKey="month"
          items={items}
        />
      </Content>
    </ColumnContainer>
  );
};

export default Settings;
